<template>
  <div>
    <span class="text-info" v-if="status == 'On Progress'">
      {{ status }} <i class="el-icon-loading"></i>
    </span>
    <span class="text-success" v-else-if="status != null">
      {{ status }}
    </span>

  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  data() {
    return {
      status: null,
      isOnProgress: false,
      id: null,
      tried: 0
    }
  },
  beforeMount() {
    this.id = this.params.data.id
    this.setStatus(this.params.data.status)
  },
  methods: {
    ...mapActions('voip-vendor-api', {getRateDocumentStatus: 'getRateDocumentStatus'}),
    setStatus(status) {
      this.status = status
      this.isOnProgress = this.status == 'On Progress'
      if (this.isOnProgress) {
        setTimeout(() => {
          this.refreshStatus()
        }, 5000)
      }
    },
    refreshStatus() {
      if (this.tried < 32) {
        this.tried += 1
        this.getRateDocumentStatus(this.id).then((r) => {
          this.setStatus(r)
        })
      }
    }
  }
}
</script>
